const aiConversationsTypes = {
  RESET_AI_CONVERSATION_STATE: 'RESET_AI_CONVERSATION_STATE',

  FETCH_AI_CONVERSATIONS_BY_LEAD: {
    REQUEST: 'FETCH_AI_CONVERSATIONS_BY_LEAD.REQUEST',
    SUCCESS: 'FETCH_AI_CONVERSATIONS_BY_LEAD.SUCCESS',
    FAILURE: 'FETCH_AI_CONVERSATIONS_BY_LEAD.FAILURE',
  },

  FETCH_AI_CONVERSATION_MESSAGES: {
    REQUEST: 'FETCH_AI_CONVERSATION_MESSAGES.REQUEST',
    SUCCESS: 'FETCH_AI_CONVERSATION_MESSAGES.SUCCESS',
    FAILURE: 'FETCH_AI_CONVERSATION_MESSAGES.FAILURE',
  },

  STOP_AI_CONVERSATION: {
    REQUEST: 'STOP_AI_CONVERSATION.REQUEST',
    SUCCESS: 'STOP_AI_CONVERSATION.SUCCESS',
    FAILURE: 'STOP_AI_CONVERSATION.FAILURE',
  },
};

export default aiConversationsTypes;
